const firebaseConfig = {
  apiKey: "AIzaSyDVVe2G22Pb2mGmJmi4EHwxw9EbkIlqbx0",
  authDomain: "sazid-mostafiz-portfolio.firebaseapp.com",
  projectId: "sazid-mostafiz-portfolio",
  storageBucket: "sazid-mostafiz-portfolio.firebasestorage.app",
  messagingSenderId: "665813339270",
  appId: "1:665813339270:web:539b2d9a3e16197b89d507",
  measurementId: "G-6WMHY1F9Z6"
};

export default firebaseConfig;